/**
 * A checkbox and its label, as one target.
 *
 * Read off `auth-login.html`: an 18px native input with `accent-color`
 * `--mdx-brand`, a 10px gap, 15px label, the whole thing a `<label>` so the
 * text is clickable and the hit area is the row rather than the box.
 *
 * Native rather than a styled span: `accent-color` gets the brand colour
 * without giving up the keyboard behaviour, the indeterminate state or the
 * platform's own focus ring — none of which a div can be talked into.
 *
 * Story 3.4.
 */
import { useId, type InputHTMLAttributes } from 'react'

export function Checkbox({
  label,
  ...rest
}: Omit<InputHTMLAttributes<HTMLInputElement>, 'id' | 'type'> & { label: string }) {
  const id = useId()
  return (
    <label
      htmlFor={id}
      className="flex cursor-pointer items-center gap-mdx-10 self-start text-mdx-15 text-mdx-ink"
    >
      <input
        id={id}
        type="checkbox"
        {...rest}
        className="m-0 size-mdx-18 shrink-0 cursor-pointer accent-mdx-brand"
      />
      {label}
    </label>
  )
}
